export const GUARDS = {
    ADMINISTRATIVE: 'administrative',
    ADMIN: 'admin',
    ADMINISTRATIVE_2: 'administrative_2',
    BILLSRECEIVE: 'bills-receive', //Contas a receber
    COMMERCIAL: 'commercial', //Head e BP
    DP: 'dp',
    FINANCES: 'finances', //Contas a pagar
    GOVERNANCE: 'governance',
    INFRA: 'infra',
    JUDICIARY: 'judiciary',
    MANAGER: 'manager',
    RS: 'rs',
    CONTROLLERSHIP: 'controllership',
    BUSINESSPARTNER: 'business-partner',
    TECHMANAGEMENT: 'tech-management',
    ACCOUNTING: 'accounting',
    PEOPLE: 'people',
    BACKOFFICE: 'backoffice',
};

export const RULES = {
    [GUARDS.ADMINISTRATIVE]: {
        resources: {
            'billing-letter': ['list', 'edit'],
            'refunds': ['list'],
            'purchase-orders': ['list'],
            'reports': ['consultant'],
            'consultants': ['list', 'edit', 'public'],
            'companies': ['list',  'group'],
        },
        commonResources: ['billing-letter', 'companies', 'purchase-orders', 'refunds', 'reports'],
    },
    [GUARDS.ADMINISTRATIVE_2]: {
        resources: {
            'purchase-orders': ['list',  'edit'],
            'reports': ['consultant'],
            'projects': ['list', 'edit'],
            'companies': ['list'],
        },
        commonResources: ['purchase-orders', 'reports', 'companies', 'projects'],
    },
    [GUARDS.BILLSRECEIVE]: {
        resources: {
            'billing-letter': ['list',  'edit'],
            'purchase-orders': ['list',  'edit', 'hierarchy'],
            'companies': ['list',  'edit', 'group'],
            'projects': ['list', 'edit'],
            //   'products': ['list',  'edit'],
            'cnaes': ['list',  'edit'],
            'refunds': ['list'],
        },
        commonResources: ['billing-letter', 'purchase-orders', 'cnaes', 'companies', 'projects'],
    },
    [GUARDS.COMMERCIAL]: {
        resources: {
            'dashboard': ['list'],
            'billing-letter': ['list', 'edit'],
            'approvals': ['list'],
            'companies': ['list',  'edit', 'group', 'inventory-list', 'company-inventory-edit'],
            'consultants': ['list', 'edit'],
            'reports': ['consultant', 'billing-letter'],
            'projects': ['list', 'edit'],
            //   'products': ['list'],
            'purchase-orders': ['list',  'edit'],
        },
        commonResources: ['billing-letter', 'approvals', 'companies', 'consultants', 'projects'],
    },
    [GUARDS.DP]: {
        resources: {
            'refunds': ['list'],
            'purchase-orders': ['list',  'edit'],
            'consultants': ['list', 'edit', 'upload'],
            'reports': ['consultant'],
            'approvals': ['list',  'upload'],

        },
        commonResources: ['consultants', 'reports', 'purchase-orders', 'refunds', 'approvals'],
    },
    [GUARDS.FINANCES]: {
        resources: {
            'billing-letter': ['list',  'edit'],
            'approvals': ['list',  'edit'],
            'refunds': ['list'],
            'purchase-orders': ['list',  'edit'],
            'companies': ['list',  'edit', 'group'],
            'consultants': ['list', 'edit'],
            'reports': ['consultant', 'billing-letter'],
            'projects': ['list', 'edit'],
            //   'projects-cost': ['list',  'edit'],
            //   'products': ['list'],
            'cnaes': ['list',  'edit'],
        },
        commonResources: ['billing-letter', 'approvals', 'refunds', 'consultants', 'reports', 'purchase-orders'],
    },
    [GUARDS.GOVERNANCE]: {
        resources: {
            'log': ['list'],
            'notifications': ['list'],
            'dashboard': ['list'],
            'billing-letter': ['list',  'edit'],
            'approvals': ['list',  'edit'],
            'refunds': ['list', 'edit'],
            'purchase-orders': ['list',  'edit', 'hierarchy'],
            'companies': ['list',  'edit', 'group', 'inventory-list', 'company-inventory-edit'],
            'consultants': ['list', 'edit', 'teamGroup-list', 'upload'],
            'reports': ['consultant', 'billing-letter'],
            'projects': ['list', 'edit'],
            'cnaes': ['list',  'edit'],
            'users': ['list',  'edit'],
        },
        commonResources: ['billing-letter', 'approvals', 'refunds', 'consultants', 'reports', 'projects'],
    },
    [GUARDS.INFRA]: {
        resources: {
            'purchase-orders': ['list',  'edit'],
            'consultants': ['list', 'edit', 'public'],
            'companies': ['list'],
            'reports': ['consultant'],
            'users': ['list',  'edit'],
        },
        commonResources: ['consultants', 'reports', 'purchase-orders', 'users'],
    },
    [GUARDS.JUDICIARY]: {
        resources: {
            'purchase-orders': ['list',  'edit'],
            'companies': ['list', 'edit', 'inventory-list', 'company-inventory-edit', 'vendor-inventory-list',  'vendor-inventory-edit'],
            'consultants': ['list',  'edit', 'public'],
            'reports': ['consultant'],
            'users': ['list',  'edit'],
            'projects': ['list', 'edit'],
            //   'legal-certificates': ['list',  'edit'],
        },
        commonResources: ['consultants', 'reports', 'companies', 'purchase-orders', 'users', 'projects'],
    },
    [GUARDS.MANAGER]: {
        resources: {
            'log': ['list'],
            'notifications': ['list'],
            'dashboard': ['list'],
            'billing-letter': ['list',  'edit', 'block-up'],
            'approvals': ['list',  'edit'],
            'refunds': ['list', 'edit'],
            'purchase-orders': ['list',  'edit', 'hierarchy'],
            'companies': ['list',  'edit', 'group', 'inventory-list', 'company-inventory-edit'],
            'consultants': ['list', 'edit', 'archives'],
            'reports': ['consultant', 'byproject', 'billing-letter'],
            'projects': ['list', 'edit'],
            //   'projects-cost': ['list',  'edit'],
            //   'products': ['list',  'edit'],
            'cnaes': ['list',  'edit'],
            'users': ['list',  'edit'],
        },
        commonResources: ['purchase-orders', 'billing-letter', 'approvals', 'refunds', 'consultants', 'companies'],
    },
    [GUARDS.RS]: {
        resources: {
            'purchase-orders': ['list',  'edit'],
            'companies': ['list'],
            'consultants': ['list', 'edit', 'public'],
            'reports': ['consultant'],
            'projects': ['list', 'edit'],
        },
        commonResources: ['purchase-orders', 'companies', 'consultants', 'reports', 'projects'],
    },
    [GUARDS.CONTROLLERSHIP]: {
        resources: {
            'billing-letter': ['list', 'edit'],
            'approvals': ['list'],
            'companies': ['list'],
            'purchase-orders': ['list',  'edit'],
            'reports': ['byproject', 'consultant'],
            'projects': ['list', 'edit'],
        },
        commonResources: ['billing-letter', 'reports', 'approvals', 'purchase-orders', 'projects'],
    },
    [GUARDS.BUSINESSPARTNER]: {
        resources: {
            'consultants': ['list', 'edit'],
            'reports': ['consultant'],
            'projects': ['list', 'edit'],
            'approvals': ['list'],

        },
        commonResources: ['consultants', 'reports', 'approvals', 'projects'],
    },
    [GUARDS.PEOPLE]: {
        resources: {
            'dashboard': ['distracts'],
            'refunds': ['list', 'edit'],
            'approvals': ['list'],
            'purchase-orders': ['list', 'edit'],
            'consultants': ['list', 'edit', 'public', 'partners', 'relocation-list', 'relocation-edit'],
            'reports': ['consultant', 'distract'],
        },
        commonResources: ['consultants', 'reports', 'refunds'],
    },
    [GUARDS.TECHMANAGEMENT]: {
        resources: {
            'billing-letter': ['list', 'edit'],
            'reports': ['consultant'],
        },
        commonResources: ['billing-letter', 'reports'],
    },
    [GUARDS.ACCOUNTING]: {
        resources: {
            'approvals': ['list', 'edit'],
            'billing-letter': ['list', 'edit'],
            'companies': ['list'],
            'consultants': ['list', 'edit'],
            'cnaes': ['list',  'edit'],
            'purchase-orders': ['list',  'edit'],
            'reports': ['consultant', 'byproject'],
            'projects': ['list', 'edit'],
            'accounting-block': ['blockup'],
            'refunds': ['list', 'edit'],
        },
        commonResources: ['billing-letter', 'companies', 'approvals', 'consultants', 'purchase-orders', 'accounting-block'],
    },
};



// WEBPACK FOOTER //
// ./src/app/shared/auth/Roles.ts